class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    // Bind click only
    this.addEventListener('click', this.onClickHandler.bind(this));
  }

  onClickHandler(event) {
    event.preventDefault();

    if (this.classList.contains('loading') || this.classList.contains('disabled')) return;

    this.classList.add('loading', 'disabled');

    const url = this.dataset.url;
    if (!url) return;

    InfiniteScroll.renderSectionFetch(url);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-card-grid')?.dataset.id,
      }
    ];
  }

  static renderSectionFetch(url) {
    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        InfiniteScroll.renderPagination(responseText);
        InfiniteScroll.renderProductGridContainer(responseText);
      })
      .catch(e => console.error(e));
  }

  static renderPagination(html) {
    const currentContainer = document
      .getElementById('products-container')
      ?.querySelector('.pagination-container');

    const newContainer = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('products-container')
      ?.querySelector('.pagination-container');

    if (newContainer && currentContainer) {
      currentContainer.innerHTML = newContainer.innerHTML;
    } else if (currentContainer) {
      currentContainer.remove();
    }
  }

  static renderProductGridContainer(html) {
    const productsContainer = document.getElementById('product-card-grid');
    const products = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('product-card-grid');

    if (products && productsContainer) {
      productsContainer.insertAdjacentHTML('beforeend', products.innerHTML);
    }
  }
}

customElements.define('infinite-scroll', InfiniteScroll);
